import api from 'store/services/api';

export const updateProfileService = (newProfile: any) =>
  api(`/api/v1/user_profile/${newProfile.id}/`, {
    method: 'patch',
    data: newProfile,
  });
